import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { BoardColumn, DynamicBoardCard } from '../../board-v3.types';

@Component({
  selector: 'app-board-v3-move-card',
  templateUrl: './move-card.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  host: { class: 'block h-full min-h-0' },
})
export class MoveCardComponent {
  @Input() card: DynamicBoardCard | null = null;
  @Input() cards: DynamicBoardCard[] = [];
  @Input() columns: BoardColumn[] = [];

  @Output() close = new EventEmitter<{ columnId: string } | void>();

  search = '';

  get isBulk(): boolean {
    return this.cards.length > 1;
  }

  get selectedCount(): number {
    return this.cards.length;
  }

  get targetColumns(): BoardColumn[] {
    const query = this.search.trim().toLowerCase();
    const columns = this.columns ?? [];

    if (!query) return columns;

    return columns.filter((column) => column.name.toLowerCase().includes(query));
  }

  get hasSearch(): boolean {
    return !!this.search.trim();
  }

  onSelectColumn(column: BoardColumn): void {
    if (this.isCurrentColumn(column)) return;
    if (!this.isBulk && !this.card) return;

    this.close.emit({ columnId: column.id });
  }

  isCurrentColumn(column: BoardColumn): boolean {
    if (this.isBulk) return this.cards.every((card) => card.column_id === column.id);

    return column.id === this.card?.column_id;
  }

  onCancel(): void {
    this.close.emit();
  }
}
